import npm from '../assets/npm.png'
import vs from '../assets/vscode.png'
import netlify from '../assets/netlify.png'
import nodejs from '../assets/node-js.png'
export const Frontend = [
    {
      id: 1,
      name: "React",
      desc: "React is a declarative, efficient, and flexible JavaScript library for building user interfaces. ",
      img: "https://c8.alamy.com/zooms/9/b48e1ee86e694c90a772a0811af3182e/2ey502k.jpg",
    },
    {
      id: 2,
      name: "JavaScript",
      desc: "Javascript is used by programmers across the world to create dynamic and interactive web content like applications and browsers",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2KINqrhal2CQq7f4mTGQh5mLS2QkB-WHLdxUtlzY80df5Lp_qLmki2m9WiTcXNp7lnAM&usqp=CAU",
    },
  
    {
      id: 3,
      name: "HTML",
      desc: "HTML is the standard markup language for creating Web pages",
      img: "https://cdn.icon-icons.com/icons2/2107/PNG/512/file_type_html_icon_130541.png",
    },
    {
      id: 4,
      name: "CSS",
      desc: "Cascading Style Sheets (CSS) is a style sheet language used for describing the presentation of a document written in a markup language such as HTML or XML.",
      img: "https://dkl2gez3gijkp.cloudfront.net/lib/uploads/2012/12/css-3-help1.jpg",
    },
    {
      id: 5,
      name: "Chakra-UI",
      desc: "Chakra UI is a simple, modular and accessible component library that gives you the building blocks you need to build your React applications",
      img: "https://jquery-plugins.net/image/plugin/chakra-ui-simple-modular-accessible-ui-components-for-react-applications.png",
    },
  
  
    {
      id: 7,
      name: "NextJS",
      desc: "Next. js is a React framework that enables several extra features, including server-side rendering and generating static websites",
      img: "https://soshace.com/wp-content/uploads/2019/10/Getting-Started-with-NextJS.jpg",
    },
    {
      id: 8,
      name: "Redux",
      desc: "Redux is a predictable state container designed to help you write JavaScript apps that behave consistently across client, server, and native environments, and are easy to test",
      img: "https://w7.pngwing.com/pngs/413/852/png-transparent-redux-react-logo-javascript-dq-purple-violet-text-thumbnail.png",
    },
  ];
  
  export const Backend  = [
    {
      id: 1,
      name: "Git",
      desc: "Git is a free and open source distributed code management and Version control system that is distributed under the GNU General Public License version 2",
      img: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      style:"shadow-orange-900"
    },
   
  
    {
      id: 3,
      name: "NodeJS",
      desc: "Node. js (Node) is an open source, cross-platform runtime environment for executing JavaScript code",
      img: nodejs,
      style:"shadow-green-400"
    },
    {
      id: 4,
      name: "MongoDB",
      desc: "MongoDB is a non-relational document database that provides support for JSON-like storage",
      img: "https://www.mongodb.com/assets/images/global/leaf.png",
      style:"shadow-green-400"
    },
    {
      id: 5,
      name: "Express",
      desc: "Express is a node js web application framework that provides broad features for building web and mobile applications",
      img: "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fhackersandslackers-cdn.storage.googleapis.com%2F2020%2F05%2Fexpress.png&f=1&nofb=1&ipt=1ad3cc6707e5365ef9352aea7491609d844a5114647a3a6d250e65e0d22909c3&ipo=images",
      style:"shadow-gray-400"
    },
  ]
  
  export const Tools = [
    {
      id: 1,
      name: "NPM",
      desc: "npm is the package manager for the Node JavaScript platform",
      img: npm,
      style:"shadow-orange-900"
    },
    
  
    {
      id: 2,
      name: "VsCode",
      desc: "Visual Studio Code is a code editor redefined and optimized for building and debugging modern web and cloud applications.",
      img: vs,
      style:"shadow-sky-900"
    },
    {
      id: 3,
      name: "Postman",
      desc: "Postman is an API platform for building and using APIs.",
      img: "https://res.cloudinary.com/postman/image/upload/t_team_logo/v1629869194/team/2893aede23f01bfcbd2319326bc96a6ed0524eba759745ed6d73405a3a8b67a8",
      style:"shadow-orange-900"
    },
    {
      id: 4,
      name: "GitHub",
      desc: "GitHub is a code hosting platform for version control and collaboration",
      img: "https://santoshy1101.github.io/My-Portfolio/static/media/github.3b9e32903aa89111875d.png",
      style:'shadow-gray-400'
    },
    {
      id: 5,
      name:'Netlify',
      img: netlify,
      style:'shadow-sky-900'

    },
  
  ]